export enum AnesthesiaSectionTypes {
    None = 0,
    PreOp = 1,
    Surgery = 2,
    PostOp = 3,
    Vital = 4
}
